import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "nonwoven-mills",
  "title": "Nonwoven Mills",
  "summary": "Specialized baling for non-wovens and fibers where contamination control and platen design matter.",
  "image": "equipment/horizontal-balers/textiles.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['nonwoven-mills'];


function NonwovenMills() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"C+M identifies non-wovens as a key material for both manual tie and automatic tie horizontal balers."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Nonwoven Mill Material</h3>
              <div className="body-copy">C+M identifies non-wovens as a key material for both manual tie and automatic tie <strong>horizontal balers</strong>.</div>
              <div className="body-copy">C+M recommendations for nonwoven applications depend on the material memory, <strong>loading method</strong>, desired <strong>bale size</strong>, and whether the plant needs automatic tying or manual grade separation.</div>
              <div className="detail-points">
                <div className="detail-point">Non-wovens and fiber-like production scrap</div>
                <div className="detail-point">Manual or automatic tie options</div>
                <div className="detail-point">Selection based on memory and compression behavior</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default NonwovenMills;
